angular.module('unica_constants', [])

.constant('CONFIG', {
	baseURL: apiURL + '/api/v1',
	webURL: webURL,
	version: appVer,
	maxUploadSize: maxUploadSize
})

.constant('AUTH_EVENTS', {
	logoutSuccess: 'auth-logout-success',
	sessionTimeout: 'auth-session-timeout',
	notAuthenticated: 'auth-not-authenticated',
	notAuthorized: 'auth-not-authorized'
})

.constant('PERMISSIONS', {

	admin: {
		resources: [ 'event', 'user', 'relator', 'location', 'hospitality', 'breadcrumbs' ]
	},

	zone_manager: {
		resources: [ 'dashboard', 'approvation-list' ]
	}

})

.constant('APPROVATION_LIST_STATUS', {
	expired_zm: 'Scaduta per Manager di Zona',
	expired_am: 'Scaduta per Area Manager',
	compile:    'Da compilare',
	waiting_am: 'In Attesa Approvazione Area Manager',
	confirmed:  'Confermata',
	rejected:   'Rifiutata',
})

.constant('EVENT_TYPES',
	[
		{ type: 'business', label: 'Business' },
		{ type: 'incentive', label: 'Incentive' },
		{ type: 'other', label: 'Other' },
	]
)

.constant('TASK_TYPES',
	[
		{ type: 'speech', label: 'Speech' },
		{ type: 'meal', label: 'Pasto' },
		{ type: 'workshop', label: 'Workshop' },
	]
)

.constant('DOC_REGISTRATION_TYPES',
	[
		{
			id: 'id_card',
			label: 'Carta d\'identità',
		},
		{
			id: 'passport',
			label: 'Passaporto',
		},
		{
			id: 'driving_license',
			label: 'Patente',
		}
	]
)

.constant('ACC_RELATIONSHIPS',
	[
		{
			id: 'husband_wife',
			label: 'MARITO/MOGLIE',
		},
		{
			id: 'friend',
			label: 'AMICO/AMICA',
		},
		{
			id: 'partner',
			label: 'COMPAGNO/COMPAGNA',
		},
		{
			id: 'family',
			label: 'PADRE/MADRE',
		},
		{
			id: 'child',
			label: 'FIGLIO/FIGLIA',
		},
		{
			id: 'other',
			label: 'ALTRO',
		}
	]
)

.constant('TRANSFER_TYPES',
	[
		{
			id: 'mezzi_propri',
			label: 'Mezzo Proprio',
		},
		{
			id: 'aereo',
			label: 'Aereo',
		},
		{
			id: 'treno',
			label: 'Treno',
		}
	]
)

.constant('ROOM_OCCUPATIONS',
	[
		{ occupation: 'dus',    label: 'Doppia - Uso Singola' },
		{ occupation: 'twin',   label: 'Doppia - 2 Letti Singoli' },
		{ occupation: 'double', label: 'Matrimoniale' }
	]
)

.constant('USER_CATEGORIES',
	[
		{ category: 'agent',          label: 'Agente' },
		{ category: 'op',             label: 'OP' },
		{ category: 'collaborator',   label: 'Collaboratore' },
		{ category: 'other',          label: 'Altro' }
	]
)

.constant('USER_ROLES',
	{
		agent: [
			{ role: 'agent',            label: 'Agente' },
		],

		op: [
			{ role: 'op',               label: 'OP' },
		],

		collaborator: [
			{ role: 'collaborator',     label: 'Collaboratore' },
		],

		other: [
			{ role: 'admin',                label: 'Admin' },
			{ role: 'service',              label: 'Service' },
			{ role: 'manager',              label: 'Dirigente' },
			{ role: 'area_manager',         label: 'Area Manager' },
			{ role: 'zone_manager',         label: 'Manager di Zona' },
			{ role: 'agency',               label: 'Agenzia' },
			{ role: 'report_manager',       label: 'Report Manager' },
			{ role: 'cons_welfare',         label: 'Consulente Welfare' },
		]
	}
)

.constant('USER_SUB_ROLES',
	{
		admin: [
			{ sub_role: 'admin',                 label: 'Admin' },
		],
		service: [
			{ sub_role: 'service',               label: 'Service' },
			{ sub_role: 'hostess',               label: 'Hostess' },
		],
		area_manager: [
			{ sub_role: 'area_manager',          label: 'Area Manager' },
		],
		zone_manager: [
			{ sub_role: 'zone_manager',          label: 'Manager di Zona' },
		],
		report_manager: [
			{ sub_role: 'report_manager',        label: 'Report Manager' },
		],
		cons_welfare: [
			{ sub_role: 'cons_welfare',          label: 'Consulente Welfare' },
		],
		op: [
			{ sub_role: 'op',                    label: 'OP' },
		],
		manager: [
			{ sub_role: 'manager',               label: 'Dirigente' },
			{ sub_role: 'funz_quadro',           label: 'Funz./Quadro Dir.' },
			{ sub_role: 'impiegato',             label: 'Impiegato' },
			{ sub_role: 'coordinatore',          label: 'Coordinatore' },
			{ sub_role: 'group_leader',          label: 'Group Leader' },
			{ sub_role: 'isp_tecnico',           label: 'Ispettore Tecnico' },
			{ sub_role: 'stagista',              label: 'Stagista' },
			{ sub_role: 'parasub',               label: 'Parasubordinato' },
		],
		agency: [
			{ sub_role: 'agency',                label: 'Agenzia' },
		],
		agent: [
			{ sub_role: 'agent',                                  label: 'Agente' },
			{ sub_role: 'coagente_pf',                            label: 'Coagente PF' },
			{ sub_role: 'responsabile_intermediazione_agenzia',   label: 'Responsabile Intermediazione di Agenzia' },
			{ sub_role: 'socio_amministratore',                   label: 'Socio Amministratore' },
			{ sub_role: 'socio_non_amministratore',               label: 'Socio Non Amministratore' },
		],
		collaborator: [
			{ sub_role: 'addetto_attivita_intermediazione',                    label: 'Addetto attività di Intermediazione' },
			{ sub_role: 'amministrativo_agenzia',                              label: 'Amministrativo di Agenzia' },
			{ sub_role: 'amministrativo_subagenzia',                           label: 'Amministrativo di Subagenzia' },
			{ sub_role: 'collaboratore_subagente',                             label: 'Collaboratore del Subagente' },
			{ sub_role: 'collaboratore_libero',                                label: 'Collaboratore Libero' },
			{ sub_role: 'esattore_segnalatore',                                label: 'Esattore / Segnalatore' },
			{ sub_role: 'responsabile_attivita_intermediazione',               label: 'Responsabile attività di Intermediazione' },
			{ sub_role: 'responsabile_attivita_intermediazione_non_socio',     label: 'Responsabile attività di Intermediazione non socio' },
			{ sub_role: 'socio_amministratore_intermediari',                   label: 'Socio Amministratore degli Intermediari' },
			{ sub_role: 'subagente',                                           label: 'Subagente' },
		],
	}
)



.constant('USER_FIELDS', {
	fiscal_code: 'Cod. Fiscale',
	gfv_code: 'Cod. GFV',
	sub_role: 'Ruolo',
	role_code: 'Codice Ruolo',
	structure: 'Area',
	structure_code: 'Codice Area',
	net: 'Rete',
	ex_net_code: 'Ex Codice Rete',
	email: 'Email',
	mobile: 'Cellulare',
	last_name: 'Cognome',
	first_name: 'Nome',
	sex: 'Sesso',
	dob: 'Data di nascita',
	agency_name: 'Agenzia',
	agency_code: 'Cod. Agenzia',
	ex_agency_code: 'Ex Cod. Agenzia',
	agency_email: 'Email Agenzia',
	agency_phone: 'Tel. Agenzia',
	agency_address: 'Indirizzo Agenzia',
	agency_zip: 'CAP Agenzia',
	agency_city: 'Città Agenzia',
	agency_prov: 'Provincia Agenzia',
	zone: 'Codice Zona',
	matricola: 'Matricola',
	codice_collaboratore: 'Cod. Collaboratore',
	data_inizio_validita: 'Data Inizio Validità',
	ruolo_commerciale: 'Ruolo Commerciale',
	inquadramento_giuridico: 'Inquadramento Giuridico',
	iscrizione_rui: 'Iscrizione RUI',
	societa_coll: 'Società Coll.',
	piva_coll: 'P. Iva Coll.',
	gfv_code_societa_coll: 'Cod. GFV Società Coll.',
	role_societa_coll: 'Ruolo Società Coll.',
	role_descr_societa_coll: 'Descrizione Ruolo Società Coll.',
	approvare_self_service: 'Approv Self Service'
})

.constant('REFRESH_INTERVAL_TIME', 30000)

.constant('AWS_URL', 'eu-central-1.amazonaws.com')

.constant('DEFAULT_VIDEO_THUMB_URL', 'eu-central-1.amazonaws.com')

.constant('DEFAULT_IMAGE_THUMB_URL', 'eu-central-1.amazonaws.com');
